// Community Calendar Management APIs

/**
 * @function ApiClient#GetCalendarEventList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} startTime
 * @param {any} endTime
 * @param {any} options = {}
 */
export async function GetCalendarEventList(cid, startTime, endTime, options = {}) {
  return await this._get(`/community/${cid}/calendar/event_list?st=${startTime}&et=${endTime}`, options);
}

/**
 * @function ApiClient#AddCalendarEvent
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} event
 * @param {any} files
 * @param {any} options = {}
 */
export async function AddCalendarEvent(cid, event, files, options = {}) {
  const formData = new FormData();
  formData.set("Data", JSON.stringify(event));

  if (files) {
    files.forEach((file) => {
      formData.append("File", file);
    });
  }

  return await this._post(`/community/${cid}/calendar/event`, formData, options);
}

/**
 * @function ApiClient#UpdateCalendarEvent
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} event
 * @param {any} files
 * @param {any} options = {}
 */
export async function UpdateCalendarEvent(cid, event, files, options = {}) {
  const formData = new FormData();
  formData.set("Data", JSON.stringify(event));

  if (files) {
    files.forEach((file) => {
      formData.append("File", file);
    });
  }

  return await this._put(`/community/${cid}/calendar/event`, formData, options);
}

/**
 * @function ApiClient#DeleteCalendarEvent
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} eventid
 * @param {any} options = {}
 */
export async function DeleteCalendarEvent(cid, eventid, options = {}) {
  return await this._delete(`/community/${cid}/calendar/event/${eventid}`, options);
}
